export default "__VITE_ASSET__0DJZ72ah__"